import { useOutletContext } from 'react-router-dom'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { agreementStatusLabel } from 'modules/performance_process/components/agreements/StatusTag'
import {
  useFilter,
  useNewlyAddedFilters,
} from 'modules/performance_process/components/review/show/Filters/context'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

export const AgreementStatusFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('agreementStatus')
  const { newlyAddedFilters } = useNewlyAddedFilters()

  if (!reviewProcess.agreementsConfiguration.enabled) return null

  return (
    <Filter.SingleChoice
      label={i18n.t('performance_process.agreements.filters.status.title')}
      value={value}
      options={[
        {
          label: i18n.t('performance_process.agreements.filters.not_initiated'),
          value: 'notinitiated',
        },
        {
          label: agreementStatusLabel('pending'),
          value: 'haspendingagreement',
        },
        {
          label: agreementStatusLabel('pending_signatures'),
          value: 'haspendingesignaturesagreement',
        },
        {
          label: agreementStatusLabel('partially_signed'),
          value: 'haspartiallyesignedagreement',
        },
        {
          label: agreementStatusLabel('bounced_email'),
          value: 'hasbouncedemailagreement',
        },
        {
          label: agreementStatusLabel('declined'),
          value: 'hasdeclinedagreement',
        },
        {
          label: agreementStatusLabel('cancelled'),
          value: 'hascancelledagreement',
        },
        {
          label: agreementStatusLabel('expired'),
          value: 'hasexpiredagreement',
        },
        {
          label: agreementStatusLabel('error'),
          value: 'haserroragreement',
        },
        {
          label: agreementStatusLabel('signed'),
          value: 'hassignedagreement',
        },
        {
          label: agreementStatusLabel('completed'),
          value: 'hasesignedagreement',
        },
      ]}
      onValueChange={setValue}
      defaultOpen={newlyAddedFilters.includes('agreementStatus')}
    />
  )
}
